import {
  SimpleFilterConfiguration,
  SimpleFilterTaskDataType,
  SimpleFilterType,
} from '../interfaces'
import { Injectable } from '@angular/core'
import { TaskType } from '@wm-front/admin/graphql'
import { i18nTaskType } from '@wm-front/shared/utils'

@Injectable({ providedIn: 'root' })
export class TaskFiltersCatalogService {
  public getConfiguration(
    overrideConfiguration: SimpleFilterConfiguration<any>
  ): SimpleFilterConfiguration<any> {
    if (overrideConfiguration?.dataType !== undefined) {
      switch (overrideConfiguration.dataType) {
        case SimpleFilterTaskDataType.TYPES:
          return this.getTypesFilterConfiguration(overrideConfiguration)
      }
      switch (overrideConfiguration.dataType) {
        case SimpleFilterTaskDataType.DONE:
          return this.getDoneFilterConfiguration(overrideConfiguration)
      }
      switch (overrideConfiguration.dataType) {
        case SimpleFilterTaskDataType.REFERENCE:
          return this.getReferenceFilterConfiguration(overrideConfiguration)
      }
      switch (overrideConfiguration.dataType) {
        case SimpleFilterTaskDataType.TO_BE_DONE:
          return this.getDoneFilterConfiguration(
            overrideConfiguration,
            $localize`:@@addressInterventionsTasksFilterToDoButton:À venir`
          )
      }
    }
    return overrideConfiguration
  }

  private getTypesFilterConfiguration(
    overrideConfiguration: SimpleFilterConfiguration<void>
  ): SimpleFilterConfiguration<void> {
    return {
      key: overrideConfiguration.key || 'types',
      display: overrideConfiguration.display || {
        label: $localize`:@@FiltersTypeButton:Types`,
      },
      type: SimpleFilterType.DROPDOWN,
      withoutSearch: true,
      data: Object.keys(TaskType).map((type) => {
        return {
          label: i18nTaskType(TaskType[type]),
          value: TaskType[type],
        }
      }),
    }
  }

  private getDoneFilterConfiguration(
    overrideConfiguration: SimpleFilterConfiguration<void>,
    toBeDoneLabel?: string
  ): SimpleFilterConfiguration<void> {
    return {
      key: overrideConfiguration?.key || 'isDone',
      urlName: 'isDone',
      type: SimpleFilterType.TOGGLE,
      required: true,
      data: [
        {
          label: $localize`:@@adminOperationsMonitoringFeatureAdminOperationsMonitoringTasksFilterDoneButton:Terminées`,
          value: true,
          checked: true,
        },
        {
          label:
            toBeDoneLabel ||
            $localize`:@@adminOperationsMonitoringFeatureAdminOperationsMonitoringTasksFilterToDoButton:À faire`,
          value: false,
        },
      ],
    }
  }

  private getReferenceFilterConfiguration(
    overrideConfiguration: SimpleFilterConfiguration<void>
  ): SimpleFilterConfiguration<void> {
    return {
      key: 'reference',
      display: overrideConfiguration.display || {
        label: $localize`:@@taskFiltersCatalogReference:Reference`,
      },
      classes: ['narrow'],
      type: SimpleFilterType.TEXT,
    }
  }
}
